import { Helmet } from 'react-helmet'

const skills = [
  {
    name: 'React JS',
    pct: 85,
    color: '#61DAFB',
    icon: (
      // Official React atom SVG — stroke-based ellipses, correct at any size
      <svg viewBox="-11 -10.5 23 21" xmlns="http://www.w3.org/2000/svg">
        <circle r="2.05" fill="#61DAFB" />
        <g fill="none" stroke="#61DAFB" strokeWidth="1">
          <ellipse rx="11" ry="4.2" />
          <ellipse rx="11" ry="4.2" transform="rotate(60)" />
          <ellipse rx="11" ry="4.2" transform="rotate(120)" />
        </g>
      </svg>
    ),
  },
  {
    name: 'Next JS',
    pct: 85,
    color: '#ffffff',
    icon: (
      <svg viewBox="0 0 128 128">
        <circle cx="64" cy="64" r="64" fill="#000" />
        <path fill="url(#nj-a)" d="M106.317 112.014 49.167 38.4H38.4v51.179h8.614v-40.24l52.54 67.884a64.216 64.216 0 0 0 6.763-5.209z" />
        <path fill="url(#nj-b)" d="M81.778 38.4h8.533v51.2h-8.533z" />
        <defs>
          <linearGradient id="nj-a" x1="109" x2="144.5" y1="116.5" y2="160.5" gradientTransform="scale(.71111)" gradientUnits="userSpaceOnUse">
            <stop stopColor="#fff" /><stop offset="1" stopColor="#fff" stopOpacity="0" />
          </linearGradient>
          <linearGradient id="nj-b" x1="121" x2="120.799" y1="54" y2="106.875" gradientTransform="scale(.71111)" gradientUnits="userSpaceOnUse">
            <stop stopColor="#fff" /><stop offset="1" stopColor="#fff" stopOpacity="0" />
          </linearGradient>
        </defs>
      </svg>
    ),
  },
  {
    name: 'Redux',
    pct: 90,
    color: '#764ABC',
    icon: (
      <svg viewBox="0 0 128 128" fill="#764ABC">
        <path d="M88.69 88.11c-9 18.4-24.76 30.78-45.61 34.85a39.73 39.73 0 0 1-9.77 1.14c-12 0-23-5-28.34-13.19C-2.2 100-4.64 76.87 19 59.76c.48 2.61 1.46 6.19 2.11 8.31A38.24 38.24 0 0 0 10 81.1c-4.4 8.64-3.91 17.27 1.3 25.25 3.6 5.38 9.3 8.65 16.63 9.65a44 44 0 0 0 26.55-5c12.71-6.68 21.18-14.66 26.72-25.57a9.32 9.32 0 0 1-2.61-6A9.12 9.12 0 0 1 87.37 70h.34a9.15 9.15 0 0 1 1 18.25zm28.67-20.2c12.21 13.84 12.54 30.13 7.82 39.58-4.4 8.63-16 17.27-31.6 17.27a50.48 50.48 0 0 1-21-5.05c2.29-1.63 5.54-4.24 7.33-5.87a41.54 41.54 0 0 0 16 3.42c10.1 0 17.75-4.72 22.31-13.35 2.93-5.7 3.1-12.38.33-19.22a43.61 43.61 0 0 0-17.27-20.85 62 62 0 0 0-34.74-10.59h-2.93a9.21 9.21 0 0 1-8 5.54h-.31a9.13 9.13 0 0 1-.3-18.25h.33a9 9 0 0 1 8 4.89h2.61c20.8 0 39.06 7.98 51.42 22.48zm-82.75 23a7.31 7.31 0 0 1 1.14-4.73c-9.12-15.8-14-35.83-6.51-56.68C34.61 13.83 48.13 3.24 62.79 3.24c15.64 0 31.93 13.69 33.88 40.07-2.44-.81-6-2-8.14-2.44-.53-8.63-7.82-30.13-25.09-29.81-6.19.17-15.31 3.1-20 9.12a43.69 43.69 0 0 0-9.64 25.25 59.61 59.61 0 0 0 8.47 36.16 2.75 2.75 0 0 1 1.14-.16h.32a9.121 9.121 0 0 1 .33 18.24h-.33a9.16 9.16 0 0 1-9.12-8.79z" />
      </svg>
    ),
  },
  {
    name: 'Firebase',
    pct: 90,
    color: '#FFCA28',
    icon: (
      <svg viewBox="0 0 128 128">
        <path fill="#FFA000" d="M17.474 103.276 33.229 2.462a2.91 2.91 0 0 1 5.44-.924l16.294 30.39 6.494-12.366a2.91 2.91 0 0 1 5.15 0l43.97 83.714H17.474Z" />
        <path fill="#F57C00" d="M71.903 64.005 54.955 31.913l-37.481 71.363Z" />
        <path fill="#FFCA28" d="M110.577 103.276 98.51 28.604a2.913 2.913 0 0 0-4.924-1.572l-76.112 76.243 42.115 23.618a8.728 8.728 0 0 0 8.51 0l42.478-23.618Z" />
      </svg>
    ),
  },
  {
    name: 'Node JS',
    pct: 75,
    color: '#339933',
    icon: (
      <svg viewBox="0 0 128 128">
        <path fill="#339933" d="M66.958.825a6.07 6.07 0 0 0-6.035 0L11.103 29.76c-1.895 1.072-2.96 3.095-2.96 5.24v57.988c0 2.143 1.183 4.167 2.958 5.24l49.82 28.934a6.07 6.07 0 0 0 6.036 0l49.82-28.935c1.894-1.072 2.958-3.096 2.958-5.24V35c0-2.144-1.183-4.167-2.958-5.24z" />
        <path fill="#fff" d="M116.897 29.76 66.841.825A8.161 8.161 0 0 0 65.302.23L9.21 96.798a6.251 6.251 0 0 0 1.657 1.43l50.057 28.934c1.42.833 3.076 1.072 4.615.595l52.66-96.925a3.702 3.702 0 0 0-1.302-1.072z" opacity=".15" />
        <path fill="#fff" d="M116.898 98.225c1.42-.833 2.485-2.262 2.958-3.81L65.066.108c-1.42-.238-2.959-.119-4.26.715L11.104 29.639l53.606 98.355c.71-.12 1.54-.358 2.25-.715z" opacity=".15" />
      </svg>
    ),
  },
  {
    name: 'Express JS',
    pct: 80,
    color: '#888',
    icon: (
      <svg viewBox="0 0 128 128">
        <path fill="#888" d="M126.67 98.44c-4.56 1.16-7.38.05-9.91-3.75-5.68-8.51-11.95-16.63-18-24.9-.78-1.07-1.59-2.12-2.6-3.45C89 76 81.85 85.2 75.14 94.77c-2.4 3.42-4.92 4.91-9.4 3.7l26.92-36.13L67.6 29.71c4.31-.84 7.29-.41 9.93 3.45 5.83 8.52 12.26 16.63 18.67 25.21 6.45-8.55 12.8-16.67 18.8-25.11 2.41-3.42 5-4.72 9.33-3.46-3.28 4.35-6.49 8.63-9.72 12.88-4.36 5.73-8.64 11.53-13.16 17.14-1.61 2-1.35 3.3.09 5.19C109.9 76 118.16 87.1 126.67 98.44zM1.33 61.74c.72-3.61 1.2-7.29 2.2-10.83 6-21.43 30.6-30.34 47.5-17.06C60.93 41.64 63.39 52.62 62.9 65H7.1c-.84 22.21 15.15 35.62 35.53 28.78 7.15-2.4 11.36-8 13.47-15 1.07-3.51 2.84-4.06 6.14-3.06-1.69 8.76-5.52 16.08-13.52 20.66-12 6.86-29.13 4.64-38.14-4.89C5.26 85.89 3 78.92 2 71.39c-.15-1.2-.46-2.38-.7-3.57q.03-3.04.03-6.08zm5.87-1.49h50.43c-.33-16.06-10.33-27.47-24-27.57-15-.12-25.78 11.02-26.43 27.57z" />
      </svg>
    ),
  },
  {
    name: 'MongoDB',
    pct: 75,
    color: '#47A248',
    icon: (
      <svg viewBox="0 0 128 128">
        <path fill="#47A248" d="M88.038 42.812c1.605 4.643 2.761 9.383 3.141 14.296.472 6.095.256 12.147-1.029 18.142-.035.165-.109.32-.164.48-.403.001-.814-.049-1.208.012-3.329.523-6.655 1.065-9.981 1.604-3.438.557-6.881 1.092-10.313 1.687-1.216.21-2.721-.041-3.212 1.641-.014.046-.154.054-.235.08l.166-10.051-.169-24.252 1.602-.275c2.62-.429 5.24-.864 7.862-1.281 3.129-.497 6.261-.98 9.392-1.465 1.381-.215 2.764-.412 4.148-.618z" />
        <path fill="#47A248" d="M61.729 110.054c-1.69-1.453-3.439-2.842-5.059-4.37-8.717-8.222-15.093-17.899-18.233-29.566-.865-3.211-1.442-6.474-1.627-9.792-.13-2.322-.318-4.665-.154-6.975.437-6.144 1.325-12.229 3.127-18.147l.099-.138c.175.233.427.439.516.702 1.759 5.18 3.505 10.364 5.242 15.551 5.458 16.3 10.909 32.604 16.376 48.9.107.318.384.579.583.866l-.87 2.969z" />
        <path fill="#47A248" d="M88.038 42.812c-1.384.206-2.768.403-4.149.616-3.131.485-6.263.968-9.392 1.465-2.622.417-5.242.852-7.862 1.281l-1.602.275-.012-1.045c-.053-.859-.144-1.717-.154-2.576-.069-5.478-.112-10.956-.18-16.434-.042-3.429-.105-6.857-.175-10.285-.043-2.13-.089-4.261-.185-6.388-.052-1.143-.236-2.28-.311-3.423-.042-.657.016-1.319.029-1.979.817 1.583 1.616 3.178 2.456 4.749 1.327 2.484 3.441 4.314 5.344 6.311 7.523 7.892 12.864 17.068 16.193 27.433z" />
        <path fill="#3d8b3d" d="M65.036 80.753c.081-.026.222-.034.235-.08.491-1.682 1.996-1.431 3.212-1.641 3.432-.594 6.875-1.13 10.313-1.687 3.326-.539 6.652-1.081 9.981-1.604.394-.062.805-.011 1.208-.012-.622 2.22-1.112 4.488-1.901 6.647-.896 2.449-1.98 4.839-3.131 7.182a49.142 49.142 0 01-6.353 9.763c-1.919 2.308-4.058 4.441-6.202 6.548-1.185 1.165-2.582 2.114-3.882 3.161l-.337-.23-1.214-1.038-1.256-2.753a41.402 41.402 0 01-1.394-9.838l.023-.561.171-2.426c.057-.828.133-1.655.168-2.485.129-2.982.241-5.964.359-8.946z" />
      </svg>
    ),
  },
  {
    name: 'Git',
    pct: 85,
    color: '#F05032',
    icon: (
      <svg viewBox="0 0 128 128" fill="#F05032">
        <path d="M124.737 58.378L69.621 3.264c-3.172-3.174-8.32-3.174-11.497 0L46.68 14.71l14.518 14.518c3.375-1.139 7.243-.375 9.932 2.314 2.703 2.706 3.461 6.607 2.294 9.993l13.992 13.993c3.385-1.167 7.292-.413 9.994 2.295 3.78 3.777 3.78 9.9 0 13.679a9.673 9.673 0 01-13.683 0 9.677 9.677 0 01-2.105-10.521L68.574 47.933l-.002 34.341a9.708 9.708 0 012.559 1.828c3.778 3.777 3.778 9.898 0 13.683-3.779 3.777-9.904 3.777-13.679 0-3.778-3.784-3.778-9.905 0-13.683a9.65 9.65 0 013.167-2.11V47.333a9.581 9.581 0 01-3.167-2.111c-2.862-2.86-3.551-7.06-2.083-10.576L41.056 20.333 3.264 58.123a8.133 8.133 0 000 11.5l55.117 55.114c3.174 3.174 8.32 3.174 11.499 0l54.858-54.858a8.135 8.135 0 00-.001-11.501z" />
      </svg>
    ),
  },
  {
    name: 'Bootstrap',
    pct: 95,
    color: '#7952B3',
    icon: (
      <svg viewBox="0 0 128 128" fill="#7952B3">
        <path d="M27.235 13.885c-7.177 0-12.486 6.284-12.249 13.099.228 6.546-.068 15.026-2.203 21.94-2.14 6.936-5.76 11.319-11.673 11.883v6.387c5.913.563 9.533 4.947 11.673 11.883 2.135 6.914 2.43 15.394 2.203 21.94-.238 6.815 5.072 13.098 12.249 13.098h73.54c7.177 0 12.486-6.284 12.249-13.098-.228-6.546.068-15.026 2.202-21.94 2.14-6.935 5.751-11.319 11.664-11.883v-6.387c-5.913-.563-9.523-4.947-11.664-11.883-2.134-6.914-2.43-15.394-2.202-21.94.237-6.815-5.072-13.099-12.25-13.099zm58.114 61.686c0 9.384-7.002 15.073-18.621 15.073H45.306a.491.491 0 01-.491-.491V37.827a.491.491 0 01.491-.492h21.309c9.689 0 16.047 5.246 16.047 13.3 0 5.653-4.277 10.713-9.727 11.6v.296c7.418.813 12.414 5.948 12.414 13.04zM64.571 44.096H53.293v15.922h9.5c7.342 0 11.391-2.955 11.391-8.238 0-4.95-3.481-7.684-9.613-7.684zm-11.278 22.24v17.548h11.695c7.645 0 11.695-3.066 11.695-8.83 0-5.763-4.163-8.718-12.187-8.718z" />
      </svg>
    ),
  },
  {
    name: 'Tailwind CSS',
    pct: 95,
    color: '#06B6D4',
    icon: (
      <svg viewBox="0 0 128 128" fill="#06B6D4">
        <path d="M64.004 25.602c-17.067 0-27.73 8.53-32 25.597 6.398-8.531 13.867-11.73 22.398-9.597 4.871 1.214 8.352 4.746 12.207 8.66C72.883 56.629 80.145 64 96.004 64c17.066 0 27.73-8.531 32-25.602-6.399 8.536-13.867 11.735-22.399 9.602-4.87-1.215-8.347-4.746-12.207-8.66-6.27-6.367-13.53-13.738-29.394-13.738zM32.004 64c-17.066 0-27.73 8.531-32 25.602C6.402 81.066 13.87 77.867 22.402 80c4.871 1.215 8.352 4.746 12.207 8.66 6.274 6.367 13.536 13.738 29.395 13.738 17.066 0 27.73-8.53 32-25.597-6.399 8.531-13.867 11.73-22.399 9.597-4.87-1.214-8.347-4.746-12.207-8.66C55.128 71.371 47.868 64 32.004 64z" />
      </svg>
    ),
  },
  {
    name: 'React Native',
    pct: 78,
    color: '#61DAFB',
    icon: (
      <svg viewBox="-11 -10.5 23 21" xmlns="http://www.w3.org/2000/svg">
        <circle r="2.05" fill="#61DAFB" />
        <g fill="none" stroke="#61DAFB" strokeWidth="1">
          <ellipse rx="11" ry="4.2" />
          <ellipse rx="11" ry="4.2" transform="rotate(60)" />
          <ellipse rx="11" ry="4.2" transform="rotate(120)" />
        </g>
      </svg>
    ),
  },
  {
    name: 'Supabase',
    pct: 72,
    color: '#3ECF8E',
    icon: (
      <svg viewBox="0 0 128 128">
        <defs>
          <linearGradient id="sb-a" x1="53.4" y1="137.2" x2="94.1" y2="46.4" gradientUnits="userSpaceOnUse">
            <stop offset="0" stopColor="#249361" />
            <stop offset="1" stopColor="#3ecf8e" />
          </linearGradient>
          <linearGradient id="sb-b" x1="36.6" y1="22.4" x2="60.7" y2="68.9" gradientUnits="userSpaceOnUse">
            <stop offset="0" stopColor="#000" stopOpacity=".2" />
            <stop offset="1" stopColor="#000" stopOpacity="0" />
          </linearGradient>
        </defs>
        <path fill="url(#sb-a)" d="M74.2 8.1a7.3 7.3 0 0 0-12.9 4.5v51.9H19.8a7.3 7.3 0 0 0-5.4 12.2l55.1 59.6a7.3 7.3 0 0 0 12.9-4.5V79.8h41.5a7.3 7.3 0 0 0 5.4-12.2z" />
        <path fill="url(#sb-b)" d="M74.2 8.1 20.4 67.3h40.9v64.5l.3.3V64.5H22.1z" />
      </svg>
    ),
  },
  {
    name: 'Redis',
    pct: 65,
    color: '#DC382D',
    icon: (
      // 3 stacked flat disks — drawn back-to-front so each layer overlaps the one below
      <svg viewBox="0 0 128 128" xmlns="http://www.w3.org/2000/svg">
        {/* ── Bottom disk ── */}
        <ellipse cx="64" cy="102" rx="56" ry="13" fill="#6B0F08" />
        <rect x="8" y="88" width="112" height="14" fill="#A01810" />
        <ellipse cx="64" cy="88" rx="56" ry="13" fill="#C0180B" />

        {/* ── Middle disk ── */}
        <ellipse cx="64" cy="76" rx="56" ry="13" fill="#6B0F08" />
        <rect x="8" y="62" width="112" height="14" fill="#B52015" />
        <ellipse cx="64" cy="62" rx="56" ry="13" fill="#D82C20" />

        {/* ── Top disk ── */}
        <ellipse cx="64" cy="50" rx="56" ry="13" fill="#6B0F08" />
        <rect x="8" y="36" width="112" height="14" fill="#D82C20" />
        <ellipse cx="64" cy="36" rx="56" ry="13" fill="#E84A38" />

        {/* ── White shapes on top face (Redis symbol) ── */}
        <circle cx="37" cy="36" r="8" fill="white" opacity="0.92" />
        <polygon points="60,28 72,44 48,44" fill="white" opacity="0.92" />
        <rect x="76" y="30" width="14" height="12" rx="2" fill="white" opacity="0.92" />
      </svg>
    ),
  },
  {
    name: 'Cloudflare',
    pct: 60,
    color: '#F48120',
    icon: (
      <svg viewBox="0 0 128 128">
        <path fill="#F48120" d="M88.6 65.1c.4-1.3.5-2.6.4-3.9-1-9.4-9.1-16.7-18.9-16.7-7.7 0-14.4 4.5-17.7 11.1-.7-.3-1.4-.4-2.1-.4-4.7 0-8.6 3.5-9.2 8-5.2.7-9.1 5.1-9.1 10.5 0 5.8 4.7 10.6 10.6 10.6h45.1c4.9 0 8.9-4 8.9-8.9 0-4.4-3.2-8.1-7.5-8.8l-.5-.5z" />
        <path fill="#FBAD41" d="M101.4 71.7c-.2-.8-.9-1.4-1.8-1.4H71.9c-.3 0-.5.1-.7.2-.2.1-.3.4-.3.6l.4 2.4c.1.6.7 1 1.3 1h27.7c.9 0 1.5-.7 1.5-1.5-.1-.5-.2-.9-.4-1.3z" />
        <path fill="#fff" d="M79.2 72.7l.4 2.5h-9.5l-.4-2.5h9.5z" />
      </svg>
    ),
  },
]

export default function Skills() {
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Usman Arif | Skills</title>
        <meta name="description" content="Muhammad Usman Arif | Skills & Expertise" />
        <meta name="keywords" content="usmanarif, Muhammad Usman Arif, skills, MERN stack" />
      </Helmet>

      <div id="skills-section" data-aos="fade-left">
        <div className="section-heading">
          <span className="section-tag">What I Know</span>
          <h2>My <span className="gradient-text">Skills</span></h2>
          <div className="heading-bar" />
        </div>

        <div className="skills-grid pb-5">
          {skills.map((skill) => (
            <div className="skill-card" key={skill.name}>
              <div className="skill-header">
                <div className="skill-info">
                  <div
                    className="skill-icon"
                    style={{ '--skill-color': skill.color }}
                  >
                    {skill.icon}
                  </div>
                  <span className="skill-name">{skill.name}</span>
                </div>
                <span className="skill-pct">{skill.pct}%</span>
              </div>
              <div className="skill-bar">
                <div
                  className="skill-fill"
                  style={{ width: `${skill.pct}%`, '--bar-color': skill.color }}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  )
}
